import { createLayer, createLayerType, line } from "eutopia.ts";
import { $, resolve } from "signlets";

import type { Position } from "../model";
import { scaleOpacity } from "./color";

export type MissionProps = {
  mission: Position[][];
  visible?: boolean;
};

export const mission = createLayerType<MissionProps>(
  (context, { mission, visible = true }) => {
    const color = $(() => scaleOpacity([1, 1, 1, 1], resolve(visible) ? 1 : 0));
    return createLayer(
      context,
      line({
        vertices: $(() =>
          resolve(mission).map(_ =>
            _.map(position => ({
              position,
              color: color(),
              width: 1,
              minWidthPixels: 2,
              pickable: false,
            })),
          ),
        ),
        pickable: false,
      }),
    );
  },
);
